/**
 * Storage helpers class
 * @class
 */
class Storage {

  private storageTestName: string = 'storage-test';
  private localStorageEnabled: boolean;
  private sessionStorageEnabled: boolean;

  constructor() {

    // Test for localStorage and sessionStorage support
    this._testLocalStorage();
    this._testSessionStorage();
  }

  private _testLocalStorage() {
    if (localStorage) {
      try {
        localStorage.setItem(this.storageTestName, this.storageTestName);
        localStorage.removeItem(this.storageTestName);

        this.localStorageEnabled = true;
      } catch (e) {
        this.localStorageEnabled = false;
      }
    } else {
      this.localStorageEnabled = false;
    }
  }

  private _testSessionStorage() {
    if (sessionStorage) {
      try {
        localStorage.setItem(this.storageTestName, this.storageTestName);
        localStorage.removeItem(this.storageTestName);

        this.sessionStorageEnabled = true;
      } catch (e) {
        this.sessionStorageEnabled = false;
      }
    } else {
      this.sessionStorageEnabled = false;
    }
  }

  private _createStorageItem(name: string, data: string | Object, expiresInMilliseconds: number) {
    var item = {
      'data': '',
      'expires': expiresInMilliseconds
    },
      dataString,
      expiresDate = new Date().getTime();

    // Stringify possible objects
    dataString = typeof data !== 'string' ? JSON.stringify(data) : data;
    item.data = dataString;

    // Set expiry date
    expiresDate += expiresInMilliseconds;
    item.expires = expiresDate;

    return item;
  }

  /**
   * Clear storage manually
   * @param storage
   * @param name
   */
  public removeLocalStorageItem(name: string){
    return window['localStorage'].removeItem(name);
  }

  private _getStorageItemData(storage: string, name) {
    var dateNow = new Date().getTime(),
      itemString: string,
      item,
      itemData;

    if (storage !== 'localStorage' &&  storage !== 'sessionStorage') {
      return null;
    }

    itemString = window[storage].getItem(name);

    if (itemString) {
      try {
        item = JSON.parse(itemString);
      } catch (err) {

      }
    }

    if (item && item.expires && item.expires >= dateNow) {

      // Try to parse data to see if it's object
      try {
        itemData = JSON.parse(item.data);
      } catch (err) {
        itemData = item.data;
      }

      return itemData;
    } else {

      // If expired delete item
      window[storage].removeItem(name);
      return null;
    }
  }

  /**
   * set localStorage item
   * @param {string}        name                  [name of item]
   * @param {string|Object} data                  [data either string or object]
   * @param {number}        expiresInMilliseconds [how long this item is valid for]
   */
  public setLocalStorageItem(name: string, data: string | Object, expiresInMilliseconds: number) {
    var item;

    if (this.localStorageEnabled) {
      item = this._createStorageItem(name, data, expiresInMilliseconds);
      localStorage.setItem(name, JSON.stringify(item));
    }
  }

  /**
   * get localStorage item if it has not expired
   * @param {string} name [name of item]
   * @return {string|object} item data
   */
  public getLocalStorageItem(name: string) {
    if (this.localStorageEnabled) {
      return this._getStorageItemData('localStorage', name);
    }

    return null;
  }

  /**
   * set sessionStorage item
   * @param {string}        name                  [name of item]
   * @param {string|Object} data                  [data either string or object]
   * @param {number}        expiresInMilliseconds [how long this item is valid for]
   */
  public setSessionStorageItem(name: string, data: string | Object, expiresInMilliseconds: number) {
    var item;

    if (this.sessionStorageEnabled) {
      item = this._createStorageItem(name, data, expiresInMilliseconds);
      sessionStorage.setItem(name, JSON.stringify(item));
    }
  }

  /**
   * get sessionStorage item if it has not expired
   * @param {string} name [name of item]
   * @return {string|object} item data
   */
  public getSessionStorageItem(name: string) {
    if (this.sessionStorageEnabled) {
      return this._getStorageItemData('sessionStorage', name);
    }

    return null;
  }

  public isSessionStorageEnabled() {
    return this.sessionStorageEnabled;
  }

  public isLocalStorageEnabled() {
    return this.localStorageEnabled;
  }


  public createCookie(name, value, days) {

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toUTCString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  public readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  public deleteCookie(name) {
    this.createCookie(name, "", -1);
  }
}

var storage = new Storage();

export { storage as Storage }
